import { useCallback, useRef, useState } from 'react';

export const useTableScroll = (): [number, (tableScroll: number) => void] => {
  const scrollRef = useRef<number>(0);
  const [, forceUpdate] = useState<number>(0);

  const setTableScroll = useCallback((newScroll: number): void => {
    scrollRef.current = newScroll;
    forceUpdate((n) => n + 1);
  }, []);

  return [scrollRef.current, setTableScroll];
};
